import { render } from "./NotFound.vue?vue&type=template&id=39898524&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=39898524&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hedde\\OneDrive\\UU\\. Honours\\opera-visualisation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39898524"]])

export default __exports__